import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "text-end" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Добавить товар ")
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Изменить ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" В архив ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_payment_list_layout = _resolveComponent("payment-list-layout")!
  const _component_payment_form_dialog = _resolveComponent("payment-form-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_payment_list_layout, {
      page: _ctx.page,
      pages: _ctx.pages,
      "per-page": _ctx.perPage,
      total: _ctx.total,
      onApply: _ctx.apply,
      onReset: _ctx.reset,
      onPageChange: _ctx.setPage
    }, {
      filter: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx.filters.search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.search) = $event)),
          placeholder: "Название",
          clearable: ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          modelValue: _ctx.filters.product_type,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.product_type) = $event)),
          clearable: "",
          placeholder: "Тип товара"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeOptions, (o) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: o.value,
                label: o.label,
                value: o.value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          modelValue: _ctx.filters.is_active,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.is_active) = $event)),
          clearable: "",
          placeholder: "Активность"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "Активные",
              value: "1"
            }),
            _createVNode(_component_el_option, {
              label: "В архиве",
              value: "0"
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: _ctx.openCreate
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          data: _ctx.items,
          "table-layout": "fixed"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "Товар",
              "min-width": "260"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.name) + " ", 1),
                _createElementVNode("div", _hoisted_3, [
                  _createTextVNode(_toDisplayString(_ctx.typeLabels[row.product_type]) + " ", 1),
                  (row.unit)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" · " + _toDisplayString(row.unit_count) + " " + _toDisplayString(row.unit), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Цена",
              width: "150",
              align: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.money(row.price)) + " ", 1),
                (row.old_price)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("s", null, _toDisplayString(_ctx.money(row.old_price)), 1),
                      (row.discount_percent)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" · −" + _toDisplayString(row.discount_percent) + "% ", 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Плательщики",
              width: "190"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.payer_types.map(t => _ctx.payerLabels[t]).join(', ')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Статус",
              width: "110"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_tag, {
                  size: "small",
                  type: row.is_active ? 'success' : 'info'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.is_active ? 'Активен' : 'В архиве'), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Действия",
              width: "230"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (_ctx.openEdit(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                (row.is_active)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      size: "small",
                      type: "danger",
                      plain: "",
                      onClick: ($event: any) => (_ctx.archive(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _: 1
    }, 8, ["page", "pages", "per-page", "total", "onApply", "onReset", "onPageChange"]),
    _createVNode(_component_payment_form_dialog, {
      modelValue: _ctx.formOpen,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formOpen) = $event)),
      title: _ctx.editing ? 'Изменить товар' : 'Новый товар',
      fields: _ctx.fields,
      initial: _ctx.initial,
      action: _ctx.save,
      onDone: _ctx.load
    }, null, 8, ["modelValue", "title", "fields", "initial", "action", "onDone"])
  ], 64))
}